const BILLING_ACCESS_KEY = 'billing_access';
const BILLING_ACCESS_CODE = 'inn2026';

const CRM_SEGMENT_ACCESS_KEY  = 'crm_segment_access';
const CRM_SEGMENT_ACCESS_CODE = 'inn2026';

/**
 * Check URL for billing access code and store in localStorage
 * Call this on app initialization
 */
export const checkBillingAccess = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('billing');

  if (code === BILLING_ACCESS_CODE) {
    localStorage.setItem(BILLING_ACCESS_KEY, 'true');
  }
};

/**
 * Check if billing menu should be visible
 */
export const isBillingEnabled = (): boolean => {
  return localStorage.getItem(BILLING_ACCESS_KEY) === 'true';
};

/**
 * Disable billing access (for testing/debugging)
 */
export const disableBillingAccess = (): void => {
  localStorage.removeItem(BILLING_ACCESS_KEY);
};

/**
 * CRM Segmentation + Promotion Codes are still a FE-only prototype
 * (see `docs/user-segment-engine.md` Faz 0.5). Until the BE ships the
 * `/user-segment/*` and `/promotion-code/*` endpoints in Faz 1 the menu
 * entries stay hidden behind a feature flag — accessing the panel with
 * `?crm-segment=inn2026` unlocks the sidebar entries; the flag persists
 * in localStorage so subsequent visits keep the menu visible.
 *
 * The routes themselves stay registered, so anyone with the direct URL
 * can still open the pages (useful for demoing without unlocking the
 * menu for the whole brand).
 */
export const checkCrmSegmentAccess = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('crm-segment');

  if (code === CRM_SEGMENT_ACCESS_CODE) {
    localStorage.setItem(CRM_SEGMENT_ACCESS_KEY, 'true');
  }
};

export const isCrmSegmentEnabled = (): boolean => {
  return localStorage.getItem(CRM_SEGMENT_ACCESS_KEY) === 'true';
};

export const disableCrmSegmentAccess = (): void => {
  localStorage.removeItem(CRM_SEGMENT_ACCESS_KEY);
};
